import { Paper as MuiPaper } from '@mui/material';

export default MuiPaper;
